import { render, staticRenderFns } from "./games-select-list.vue?vue&type=template&id=2b8ab3b8&scoped=true&"
import script from "./games-select-list.vue?vue&type=script&lang=js&"
export * from "./games-select-list.vue?vue&type=script&lang=js&"
import style0 from "./games-select-list.vue?vue&type=style&index=0&id=2b8ab3b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ab3b8",
  null
  
)

export default component.exports